import Vue from 'vue'
import axios from "axios";
import { ActionTree, MutationTree } from 'vuex'
import { RootState } from '@/store/types'
import {SERVER_HOST_QR} from "@/config";

import { IContactBlock } from "@/store/modules/lib";

export interface State {
  contacts: IContactBlock[]
  contactFields: { type: string, title: string }[]
  isLoaded: boolean,
  errorMessage: string,
  isError: boolean
}

const defaultState: State = {
  contacts: [],
  contactFields: [],
  isLoaded: false,
  errorMessage: '',
  isError: false
}

const getters = {
  contacts: (state: State) => state.contacts,
  contactFields: (state: State) => state.contactFields,
  loading: (state: State) => state.isLoaded,
  error: (state: State) => ({ text: state.errorMessage, showError: state.isError }),
}

const mutations: MutationTree<State> = {
  setLoading: (state: State, payload: boolean) => state.isLoaded = payload,
  setError: (state: State, payload: string) => {
    state.errorMessage = payload
    state.isError = true
    setTimeout(() => state.isError = false, 5000)
  }
}

const actions: ActionTree<State, RootState> = {
  async fetchContacts({ commit, state }) {
    commit('setLoading', true)
    try {
      const { data } = await axios({
        url: `${SERVER_HOST_QR}contact-block/field`,
        method: 'GET'
      })
      state.contacts = data.data.map((contact: any) => {
        return { ...contact, isEditing: false }
      })
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        messages: [e.message]
      })
    } finally {
      commit('setLoading', false)
    }
  },
  async fetchFieldsList({commit, state }) {
    commit('setLoading', true)
    try {
      const { data } = await axios({
        url: `${SERVER_HOST_QR}contact-block/field/type`,
        method: 'GET'
      })
      state.contactFields = data.data
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        messages: [e.message]
      })
    } finally {
      commit('setLoading', false)
    }
  },
  async patchContacts({ commit, state }, { contacts }) {
    commit('setLoading', true)
    try {
      const normalizedContacts = contacts.map((contact: any) => {
        delete contact.isEditing
        return contact
      })
      await axios({
        url: `${SERVER_HOST_QR}contact-block/field`,
        method: 'PATCH',
        data: normalizedContacts
      })
      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        messages: [e.message]
      })
      return false
    } finally {
      commit('setLoading', false)
    }
  }
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
